/** 中国业务展示时区 */
export const APP_TIME_ZONE = 'Asia/Shanghai';

/** 已是「YYYY-MM-DD HH:mm」墙钟字符串则原样展示，避免再被 Date 误解析 */
const APP_DATETIME_RE = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}/;

export function formatAppDateTimeDisplay(value?: string | null): string {
  if (!value) return '-';
  const trimmed = value.trim();
  if (
    APP_DATETIME_RE.test(trimmed) &&
    !/[zZ]|[+-]\d{2}:?\d{2}$/.test(trimmed)
  ) {
    return trimmed.slice(0, 16).replace('T', ' ');
  }
  const date = new Date(trimmed);
  if (Number.isNaN(date.getTime())) return trimmed;
  const fmt = new Intl.DateTimeFormat('zh-CN', {
    timeZone: APP_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
  // zh-CN 常见为 2026/09/04 16:17:29 → 统一成 -
  return fmt.format(date).replace(/\//g, '-');
}

export function nowAppDateTimeDisplay(): string {
  return formatAppDateTimeDisplay(new Date().toISOString());
}

export function todayAppDateDisplay(): string {
  const fmt = new Intl.DateTimeFormat('en-CA', {
    timeZone: APP_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
  return fmt.format(new Date());
}
